/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeploymentLogEvent = {
  /**
   * The ID of the asset tied to the log event
   */
  attachmentId?: string | undefined;
  /**
   * The type of the asset tied to the log event
   */
  attachmentType?: string | undefined;
  /**
   * The creation date of the log event
   */
  createdAt: string;
  /**
   * The type of event that occurred
   */
  event: string;
  /**
   * The ID of the log event
   */
  id: string;
  /**
   * The message of the log event
   */
  message: string;
};

/** @internal */
export const DeploymentLogEvent$inboundSchema: z.ZodMiniType<
  DeploymentLogEvent,
  unknown
> = z.pipe(
  z.object({
    attachment_id: z.optional(z.string()),
    attachment_type: z.optional(z.string()),
    created_at: z.string(),
    event: z.string(),
    id: z.string(),
    message: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "attachment_id": "attachmentId",
      "attachment_type": "attachmentType",
      "created_at": "createdAt",
    });
  }),
);

export function deploymentLogEventFromJSON(
  jsonString: string,
): SafeParseResult<DeploymentLogEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeploymentLogEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeploymentLogEvent' from JSON`,
  );
}
